import type { ReactNode } from 'react';
import { Collapse } from '@ksyos/design-system';
import classnames from 'classnames';
import { Icon } from './common';

interface ICollapsibleProps {
    children: ReactNode;
    className?: string;
    extraHeaderElements?: JSX.Element;
    header?: string;
    isOpen: boolean;
    noBackground?: boolean;
    subHeader?: string;
    toggle: (isOpened: boolean) => void;
}

export function Collapsible(props: ICollapsibleProps) {
    return (
        <div
            className={classnames(
                'collapsible',
                props.className ? props.className : '',
                props.noBackground ? 'no-background' : ''
            )}
        >
            <div
                className="collapse-bar"
                onClick={() => props.toggle(!props.isOpen)}
            >
                <span className="collapse-header">
                    {props.header} {props.subHeader && <span className="collapse-sub-header">{props.subHeader}</span>}
                </span>
                {props.isOpen && props.extraHeaderElements}
                <button
                    className={classnames('btn btn-dropdown', { collapsed: !props.isOpen })}
                    onClick={() => props.toggle(!props.isOpen)}
                    type="button"
                >
                    <Icon icon="caret" />
                </button>
            </div>
            <Collapse isOpen={props.isOpen}>{props.children}</Collapse>
        </div>
    );
}
